import z from 'zod';
import { createRoute } from '../functions/createRoute';
export const DashboardRoute = createRoute('dashboard', {
    path: '/',
    schema: z.object({}),
    exact: true,
});
export const CommunicationRoute = createRoute('communication', {
    path: '/kommunikation',
    schema: z.object({}),
    exact: true,
});
export const CalculatorsRoute = createRoute('calculators', {
    path: '/calculators',
    schema: z.object({}),
    exact: true,
});
export const ReportingRoute = createRoute('reporting', {
    path: '/reporting',
    schema: z.object({}),
    exact: true,
});
export const IssueTrackerRoute = createRoute('issue-tracker', {
    path: '/issues',
    schema: z.object({}),
    exact: false,
});
